'use client';
import { useEffect, useRef } from 'react';
import drawTallyMarks from '@/lib/visualisers/tallyMarks';

interface TallyOptions {
    strokeColor: string;
    strokeWidth: number;
}

interface TallyMarkVisualiserProps {
    count: number;
    options: TallyOptions;
}

export default function TallyMarkVisualiser({ count, options }: TallyMarkVisualiserProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        drawTallyMarks(c, { count, ...options, size: 400 });
    }, [count, options]);

    return (
        <div className="flex w-full max-w-[400px] flex-col items-center rounded-lg border-[0.5px] border-line bg-white p-5">
            <canvas
                ref={canvasRef}
                aria-label={`Visualisation of ${count} tally marks`}
                className="h-auto w-full"
            />
            <div className="mt-3 text-sm text-muted">
                Visualising{' '}
                <strong className="font-medium text-ink">{count}</strong> as tally marks
            </div>
        </div>
    );
}
